import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "한국국민금거래소 - 실시간 금시세 및 귀금속 거래",
  description = "실시간 금시세 확인, 금매입/판매, 귀금속 투자상품 안내. 순금, 18K, 14K, 백금, 은, 다이아몬드 최고가 매입",
  keywords = "한국국민금거래소, 금거래, 금투자, 금시세, 금매매, 투자, 귀금속, 금값, 금시세표, 순금, 18K, 14K, 백금, 은, 다이아몬드, 금반지, 금목걸이, 금팔찌, 금매입, 금판매, 금거래소",
  url = "https://koreakookmingold.com",
  image = "https://koreakookmingold.com/images/logo.png"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
